import { Component, inject, ChangeDetectionStrategy } from '@angular/core'
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog'
import { MatButtonModule } from '@angular/material/button'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatInputModule } from '@angular/material/input'
import { MatIconModule } from '@angular/material/icon'
import { FormsModule } from '@angular/forms'
import { TranslationService } from '../../../services/translation.service'

export interface DiscontinuedYearDialogData {
  defaultYear?: number
}

@Component({
  selector: 'app-discontinued-year-dialog',
  imports: [
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    FormsModule,
  ],
  templateUrl: './discontinued-year-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './discontinued-year-dialog.component.scss',
})
export class DiscontinuedYearDialogComponent {
  translationService = inject(TranslationService)
  private dialogRef =
    inject<MatDialogRef<DiscontinuedYearDialogComponent, number>>(MatDialogRef)
  data = inject<DiscontinuedYearDialogData>(MAT_DIALOG_DATA)

  year: number | null
  readonly minYear = 2024
  readonly maxYear = new Date().getFullYear()

  constructor() {
    const data = this.data

    const initialYear = data?.defaultYear ?? this.maxYear
    this.year = Math.min(Math.max(initialYear, this.minYear), this.maxYear)
  }

  onCancel(): void {
    this.dialogRef.close()
  }

  onSave(): void {
    if (
      this.year != null &&
      this.year >= this.minYear &&
      this.year <= this.maxYear
    ) {
      this.dialogRef.close(this.year)
    }
  }
}
